module.exports = __webpack_public_path__ + "img/ma3.8cbccab3.jpg";